import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconTag"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4.75C2 3.23122 3.23122 2 4.75 2H11.1616C11.8909 2 12.5904 2.28973 13.1061 2.80546L21.1161 10.8155C22.1901 11.8894 22.1901 13.6306 21.1161 14.7045L14.7045 21.1161C13.6306 22.1901 11.8894 22.1901 10.8155 21.1161L2.80546 13.1061C2.28973 12.5904 2 11.8909 2 11.1616V4.75ZM7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTag;
